import { Basic } from "./Basic";
import { Custom } from "./Custom";

export const Pagination = {
  Basic,
  Custom,
};
